/* reducer is used in client area */
import {
    FETCH_PRODUCTS,USER_LOGOUT, UPDATE_PRODUCT,FETCH_PRODUCT }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [], total: 'initial'};
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_PRODUCTS:
            console.log(`FETCH_PRODUCTS${action.payload}`);
            return {
                data: action.payload.data,
                total: action.payload.total
            }
        case UPDATE_PRODUCT:
            console.log('UPDATE_PRODUCT', state, action.payload);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload._id});
            return { ...state,
                data: [...state.data.slice(0, itemIndex),
                    action.payload,
                    ...state.data.slice(itemIndex + 1)],

            }
        case FETCH_PRODUCT:
            console.log("FETCH_PRODUCT", action.payload);
            return {
                data: state.data.concat([action.payload]),
                total: 1
            }
        case USER_LOGOUT:
             return initialState;
        default:
            return state;
    }
}

export const getClientProduct = (state, id) => {
    return state.products.data.filter(record => record._id === id)[0];
}